import * as React from "react";
function CrossIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "50px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.03 20.03 15-15a.75.75 0 0 0-1.06-1.06l-15 15a.75.75 0 1 0 1.06 1.06m-1.06-15 15 15a.75.75 0 1 0 1.06-1.06l-15-15a.75.75 0 0 0-1.06 1.06"
  }));
}
export default CrossIcon;